import React, { type FC, type PropsWithChildren } from 'react';

type StartQuoteProps = {
  /** The color of the icon. */
  color?: string;
};

const StartQuote: FC<PropsWithChildren<StartQuoteProps>> = ({ color = 'currentcolor' }) => (
  <svg fill="none" height="43" viewBox="0 0 70 43" width="70" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M37.8161 19.1707C37.571 18.0813 37.4419 16.9498 37.4419 15.7891C37.4419 7.06901 44.7302 2.20915e-06 53.7209 1.42316e-06C62.7116 6.37171e-07 70 7.069 70 15.7891C70 24.5091 62.7116 31.5781 53.7209 31.5781C53.6037 31.5781 53.4867 31.5769 53.37 31.5745L53.3745 31.5781C54.8754 34.4896 58.8471 40.85 62.7263 43C55.1064 41.4323 39.4507 34.4672 37.7882 19.1484L37.8161 19.1707Z"
      fill={color}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M0.374254 19.1707C0.12916 18.0813 2.437e-05 16.9498 2.42685e-05 15.7891C2.35062e-05 7.06902 7.28841 1.74679e-05 16.2791 1.6682e-05C25.2698 1.5896e-05 32.5582 7.06902 32.5582 15.7891C32.5582 24.5091 25.2698 31.5781 16.2791 31.5781C16.1618 31.5781 16.0449 31.5769 15.9282 31.5745L15.9327 31.5781C17.4336 34.4896 21.4053 40.85 25.2845 43C17.6645 41.4323 2.00893 34.4672 0.346384 19.1485L0.374254 19.1707Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default StartQuote;
